






























import { Component, Prop, Vue } from 'vue-property-decorator'
import DateTimePicker from '@/app/ui/components/DateTimePicker/index.vue'

@Component({
  inheritAttrs: false,
  components: { DateTimePicker },
})
export default class PNDatePicker extends Vue {
  @Prop({ default: false }) private required!: boolean
  @Prop({ required: true }) private fieldLabel!: string
  @Prop() private fieldDescription!: string
  @Prop() private fieldSuffix!: string
  @Prop() private errorMessage!: string
}
